import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { v4 as uuidv4 } from "uuid";
import {
  Stack,
  Snackbar,
  SnackbarContent,
  Button,
  Typography,
  Link,
  Slide,
} from "@mui/material";
import * as constants from "../constants";

function TransitionUp(props) {
  return (
    <Slide {...props} direction="up" timeout={{ enter: 500, exit: 500 }} />
  );
}

export default function CookieConsent() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!Cookies.get("IES_CONFERENCE_COMMUNITY_COOKIE")) {
      setOpen(true);
    }
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const handleAccept = () => {
    Cookies.set("IES_CONFERENCE_COMMUNITY_COOKIE", uuidv4(), {
      expires: 90,
    });

    handleClose();
  };

  const action = (
    <Button color="light" size="small" onClick={() => handleAccept()}>
      ACCEPT
    </Button>
  );

  const message = (
    <Typography variant="body2" align="justify">
      IEEE websites place cookies on your device to give you the best user
      experience. By using our websites, you agree to the placement of these
      cookies. To learn more, read our{" "}
      <Link
        color="#8089cb"
        href={constants.IEEE_PRIVACY_POLICY}
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy Policy.
      </Link>
    </Typography>
  );

  return (
    <Snackbar
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      TransitionComponent={TransitionUp}
      open={open}
      message={message}
    >
      <Stack spacing={2} sx={{ maxWidth: 700 }}>
        <SnackbarContent message={message} action={action} />
      </Stack>
    </Snackbar>
  );
}
